const IconAlertNeutral = (): JSX.Element => {
  return (
    <>
      <path
        d="M11.98,3.01c-4.97,0-9,4.03-9,9c0,4.97,4.03,9,9,9c4.97,0,9-4.03,9-9
	  C20.98,7.03,16.95,3.01,11.98,3.01z M0.98,12.01c0-6.08,4.92-11,11-11c6.08,0,11,4.92,11,11c0,6.08-4.92,11-11,11
	  C5.91,23.01,0.98,18.08,0.98,12.01z M10.98,8.01c0-0.55,0.45-1,1-1h0.01c0.55,0,1,0.45,1,1c0,0.55-0.45,1-1,1h-0.01
	  C11.43,9.01,10.98,8.56,10.98,8.01z M11.98,11.01c0.55,0,1,0.45,1,1v4c0,0.55-0.45,1-1,1s-1-0.45-1-1v-4
	  C10.98,11.45,11.43,11.01,11.98,11.01z"
      />
    </>
  );
};

export default IconAlertNeutral;
